import { ChevronDown, ChevronUp, ChevronsUpDown } from "lucide-react";

interface SortIndicatorProps {
  direction: false | "asc" | "desc";
}

export function SortIndicator({ direction }: SortIndicatorProps) {
  const sortedIconProps = {
    className: "text-brand-blue size-3.5",
    strokeWidth: 3,
  };

  if (direction === "asc") {
    return <ChevronUp {...sortedIconProps} />;
  }
  if (direction === "desc") {
    return <ChevronDown {...sortedIconProps} />;
  }
  return (
    <ChevronsUpDown className="group-hover:text-brand-blue size-3.5 text-[#8A94A6]" />
  );
}
